const defaultState = {
  data: [],
  inactiveData: [],
  loading: false,
  error: false,
};

const users = function (state = defaultState, action) {
  let data, inactiveData, target;

  switch (action.type) {
    case 'SET_USERS':
      return { ...state, data: action.data };

    // users that have been deactivated. So that they can be reactivated in admin
    case 'SET_INACTIVE_USERS':
      console.log('setting inactive userfs');
      return { ...state, inactiveData: action.data };

    case 'UPDATE_USER':
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data[target] = { ...data[target], ...action.data };
      }
      return { ...state, data };

    case 'REMOVE_USER':
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, data };

    case 'MAKE_INACTIVE_USER_ACTIVE':
      // remove user code
      inactiveData = [...state.inactiveData];
      target = inactiveData.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        inactiveData.splice(target, 1);
      }
      return { ...state, inactiveData, data: [...state.data, action.data] };

    case 'INSERT_USER':
      return { ...state, data: [...state.data, action.data] };

    case 'SET_USERS_LOADING':
      return {
        ...state,
        loading: action.data,
      };

    case 'SET_USERS_ERROR':
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default users;
